import { downloadByLinkCreation } from './downloadByLinkCreation';

/**
 * Creates a link element with the file content as a base64 encoded string and the suggested filename.
 * Clicks the link to download the file and removes the link from the DOM.
 * @param response The response of fetched api.
 * @returns void
 */
export const downloadJSONFromApi = (response: any) => {
  if (!response) return;

  const blob = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' });

  const href = URL.createObjectURL(blob);
  const download = `${response.orderNumber}.json`;

  downloadByLinkCreation(href, download);
};

export const downloadStringifiedJSONFromApi = (response: any) => {
  if (!response) return;
  const parsedResponse = JSON.parse(response);

  const blob = new Blob([response], { type: 'application/json' });

  const href = URL.createObjectURL(blob);
  const download = `${parsedResponse?.orderNumber}.json`;

  downloadByLinkCreation(href, download);
};
